export default __webpack_public_path__ + "static/media/carousel-chevron-left.ecc2a9a1.svg";